import React, { useMemo, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Container,
  ListItemText,
  Typography,
  Button,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TableSkeleton from "../../../../components/loader/tableLoader.jsx";
import DescriptionIcon from "@mui/icons-material/Description";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import CircleIcon from "@mui/icons-material/Circle";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";
import { getFolderEnvelopes } from "../../../../redux/docs/getFolderEnvelopes";
import ConfirmModal from "../../../../components/globalModal/ConfirmModal";
import { resendEnvelope } from "../../../../redux/docs/resendEnvelope";
import { toast } from "react-toastify";

function SignatureListing(props) {
  const { classes, setSelectedCheckboxIds, id, sortModel, onSortModelChange } =
    props;
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openVoidModal, setOpenVoidModal] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [envelopeId, setEnvelopeId] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);

  const dispatch = useDispatch();

  const agents = useSelector((state) =>
    state.users.storedListOfUsers.list.filter(
      (user) => user.is_agent === true && user.status === "active"
    )
  );
  const { data: envelopes, isLoading: isEnvelopesLoading } = useSelector(
    (state) => state.Docs.folderEnvelopes
  );
  console.log(envelopes, "envelopes");

  useEffect(() => {
    dispatch(getFolderEnvelopes(id));
  }, [dispatch, id]);

  const handleGetParticipants = (envelope_forms) => {
    return envelope_forms
      .map((form) => form.envelope_recipients)
      .flat()
      ?.map((item) => item.name)
      ?.join(", ");
  };
  // Memoized columns configuration
  const columns = useMemo(
    () => [
      {
        field: "subject",
        headerName: "Document Name",
        renderCell: (params) => (
          <Grid
            container
            className={classes.mAlign}
            alignItems="center"
            xs="auto"
          >
            <DescriptionIcon
              sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }}
            />
            <ListItemText
              primary={params.row?.subject}
              secondary={`To: ${handleGetParticipants(
                params.row?.envelope_forms
              )}`}
            />
          </Grid>
        ),
        flex: 1,
        editable: false,
        sortable: true,
      },
      {
        field: "status",
        headerName: "Status",
        renderCell: ({ row }) => (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <CircleIcon
              sx={{
                fontSize: "12px",
                color:
                  row?.status === "In Progress"
                    ? "#F2A053"
                    : row?.status === "Completed"
                    ? "#00BE2F"
                    : row?.status === "sent"
                    ? "blue"
                    : "#000000",
              }}
            />
            <Typography>{row?.status}</Typography>
          </Box>
        ),
        width: 150,
        editable: false,
        sortable: true,
      },

      {
        field: "last_updated_at",
        headerName: "Last Change",
        renderCell: (params) =>
          params.row.last_updated_at ? (
            <Grid container>
              {moment(params.row.last_updated_at).format("HH:mm MM-DD-YYYY")}
            </Grid>
          ) : null,
        width: 150,
        editable: false,
        sortable: true,
      },
      {
        headerName: "",
        type: "actions",
        renderCell: ({ row }) =>
          row.status === "Completed" ? (
            <Button
              variant="text"
              color="inherit"
              sx={{ textTransform: "capitalize", width: "120px" }}
              startIcon={<DownloadRoundedIcon />}
            >
              Download
            </Button>
          ) : null,
        width: 140,
      },
      {
        headerName: "",
        field: "void",
        renderCell: ({ row }) =>
          row.status === "Completed" ? null : (
            <Button
              variant="text"
              color="inherit"
              sx={{ textTransform: "capitalize", width: "100px" }}
              startIcon={<BlockRoundedIcon />}
              onClick={() => setOpenVoidModal(true)}
            >
              Void
            </Button>
          ),
        width: 120,
      },
      {
        headerName: "",
        field: "send",
        renderCell: ({ row }) =>
          row.status === "Completed" ? null : (
            <Button
              variant="text"
              color="inherit"
              sx={{ textTransform: "capitalize", width: "100px" }}
              startIcon={<SendRoundedIcon />}
              onClick={() => {
                setOpenConfirmModal(true);
                setEnvelopeId(row.id);
              }}
            >
              Resend
            </Button>
          ),
        width: 150,
      },
    ],
    [classes.mAlign, agents]
  );

  const handleConfirmVoid = () => {
    console.log("confirm");
    setOpenVoidModal(false);
  };
  const handleSuccess = () => {
    setResendLoading(false);
    setOpenConfirmModal(false);
    toast.success("Document resend successfully", { theme: "colored" });
  };
  const handleError = (error) => {
    setResendLoading(false);
    console.log(error);
    toast.error(JSON.stringify(error), { theme: "colored" });
  };

  const handleConfirmResend = () => {
    console.log("confirm");
    setResendLoading(true);
    dispatch(
      resendEnvelope({
        id,
        envelope_id: envelopeId,
        handleSuccess: handleSuccess,
        handleError: handleError,
      })
    );
  };
  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          height: "80vh",
          width: "100%",
          "& .Mui-checked": { color: "#1D1B20 !important" },
        }}
      >
        <DataGridPro
          loading={isEnvelopesLoading}
          components={{
            LoadingOverlay: TableSkeleton,
          }}
          rows={envelopes}
          columns={columns}
          checkboxSelection={true}
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
          onRowSelectionModelChange={setSelectedCheckboxIds}
          disableRowSelectionOnClick
          sortModel={sortModel}
          onSortModelChange={onSortModelChange}
        />
      </Box>
      <ConfirmModal
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        handleConfirm={handleConfirmResend}
        title="Resend Document"
        content="Are you sure you want to resend this document?"
        loading={resendLoading}
      />
      <ConfirmModal
        open={openVoidModal}
        setOpen={setOpenVoidModal}
        handleConfirm={handleConfirmVoid}
        title="Void Document"
        content="Are you sure you want to void this document?"
      />
    </Container>
  );
}

export default SignatureListing;
